<!--
 * @Author: wsx
 * @Date: 2021-07-12 09:35:22
 * @LastEditTime: 2021-07-22 15:16:34
 * @LastEditors: Please set LastEditors
 * @Description: 基础标题
 * @FilePath: \contingency-manage\src\components\global\XTitle.vue
-->
<template>
  <div :class="['xTitle', { backgroundImg: !(subTitle || subTitleSlot) }]">
    <!-- <i :class="['iconfont', 'titleIcon']"> -->
      <i :class="['iconfont', 'titleIcon', icon]">
      <!-- <img src="@/assets/images/home/icon.png" > -->
    </i>
    <slot></slot>
    <div
      class="xTitleSub"
      v-if="subTitleSlot || subTitle"
      @click="subTitleClick"
    >
      <template v-if="!subTitleSlot">
        {{ subTitle }}<i class="iconfont icon-changyongicon-"></i>
      </template>
      <template v-else>
        <slot name="subtitle"></slot>
      </template>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs
} from 'vue';
export default defineComponent({
  name: 'XTitle',
  components: {},
  props: {
    icon: {
      type: String,
      default: 'icon-shujukanban'
    },
    subTitle: {
      type: String,
      default: ''
    },
    subTitleSlot: {
      type: Boolean,
      default: false
    }
  },
  emits: ['subClick'],
  setup(props, context) {
    const data = reactive({});
    const refData = toRefs(data);
    const subTitleClick = () => {
      context.emit('subClick');
    };
    return { ...refData, subTitleClick };
  }
});
</script>
<style  lang='scss' scoped >
.xTitle {
  width: 100%;
  height: 36px;
  font-size: 16px;
  color: #fff;
  background-size: auto 35%;
  background-position: right center;
  background-repeat: no-repeat;
  padding-left: 3px;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #6a7795;
  @include flex-row-s-c;
  &.backgroundImg {
    background-image: url("~@/assets/images/home/tit.png");
  }
  &::before {
    content: "";
    width: 6px;
    height: 2px;
    position: absolute;
    bottom: -1px;
    left: 0;
    background-color: #fff;
  }
  .iconfont {
    font-size: 18px;
  }
  .titleIcon {
    margin-right: 8px;
    position: relative;
        margin-left: -10px;
    &::before {
      color: #fff;
      z-index: 2;
      position: relative;
    }
    &::after {
      content: "";
      box-shadow: 0 0 15px 10px #5790c0;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 1px;
      height: 1px;
      z-index: 1;
    }
  }
  .xTitleSub {
    position: absolute;
    right: 0;
    color: #00a1ff;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
